import { Expose } from "class-transformer";

export class CreateAddressDto {
  @Expose()
  name: string;

  @Expose()
  address: string;

  @Expose()
  postalCode: string;

  @Expose()
  city: string;

  @Expose()
  province: string;

  @Expose()
  country: string;
}
